import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useMemo } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Box, Grid, Button, CircularProgress, Backdrop } from '@material-ui/core';
import { Drawer } from "./styles";
import { Single } from "./Single";
import { Tabbed } from "./Tabbed";
export function Filter(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Filter by' : _ref$title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'single' : _ref$variant,
    tabs = _ref.tabs,
    sections = _ref.sections,
    open = _ref.open,
    _onClose = _ref.onClose,
    onApplyFilters = _ref.onApplyFilters,
    onResetFilters = _ref.onResetFilters,
    applyClearFiltersTabIndexWhitelist = _ref.applyClearFiltersTabIndexWhitelist,
    panelWidth = _ref.panelWidth,
    panelMaxWidth = _ref.panelMaxWidth,
    onPublishEvent = _ref.onPublishEvent,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var _useTheme = useTheme(),
    duration = _useTheme.transitions.duration;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentTab = _useState2[0],
    setCurrentTab = _useState2[1];
  var shouldShowApplyAndClearFilters = useMemo(function () {
    if (variant === 'single') {
      return onApplyFilters && onResetFilters;
    }
    return onApplyFilters && onResetFilters && applyClearFiltersTabIndexWhitelist.includes(currentTab);
  }, [currentTab, applyClearFiltersTabIndexWhitelist, onApplyFilters, onResetFilters]);
  var Content = variant === 'single' ? /*#__PURE__*/React.createElement(Single, {
    sections: sections,
    title: title,
    onClose: _onClose,
    onPublishEvent: onPublishEvent
  }) : /*#__PURE__*/React.createElement(Tabbed, {
    tabs: tabs,
    onClose: _onClose,
    onChangeTab: setCurrentTab
  });
  return /*#__PURE__*/React.createElement(Drawer, {
    variant: "temporary",
    anchor: "left",
    open: open,
    transitionDuration: {
      enter: duration.enteringScreen,
      exit: duration.leavingScreen
    },
    onClose: function onClose() {
      onPublishEvent();
      _onClose();
    },
    panelWidth: panelWidth,
    panelMaxWidth: panelMaxWidth
  }, /*#__PURE__*/React.createElement(Backdrop, {
    style: {
      color: '#fff',
      zIndex: 3,
      position: 'absolute',
      height: '100%',
      width: panelMaxWidth
    },
    open: isLoading
  }, /*#__PURE__*/React.createElement(CircularProgress, null)), Content, shouldShowApplyAndClearFilters && /*#__PURE__*/React.createElement(Box, {
    mr: 5,
    ml: 5,
    mb: 5,
    mt: 0
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      onResetFilters();
      _onClose();
    },
    variant: "text",
    size: "large",
    fullWidth: true
  }, "Clear All Filters")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      onApplyFilters();
      _onClose();
    },
    variant: "contained",
    color: "primary",
    size: "large",
    fullWidth: true
  }, "Apply Filters"))))));
}